import styled, { css } from 'styled-components';
import * as InfoStyles from './componets/Info/styles';

export const Container = styled.div`
  padding-top: 38px;
`;

export const Schedule = styled.div`
  ${({ theme }) => css`
    ${InfoStyles.Container}:not(:first-child) {
      border-top: 1px solid ${theme.colors.colorGray100};
    }
  `}
`;
